/**
 * SEO Data Configuration
 * ======================
 * Centralized SEO metadata for all pages.
 * Update these values to optimize search engine visibility.
 */

import { BUSINESS_INFO } from './constants';

const BASE_URL = 'https://gupshupchitchatchai.com';

// ============================================
// PAGE-SPECIFIC SEO DATA
// ============================================
export const SEO_DATA = {
  home: {
    title: 'Gup Shup – Chit Chat Chai | Romford\'s Favourite Chai Cafe & Street Food Spot | Collier Row',
    description: '★ 4.8/5 from 1000+ reviews ★ Romford\'s best chai cafe! Gup Shup serves authentic karak chai, samosas, pakoras & desi street snacks in Collier Row RM5. The cozy chai cafe near you – order now!',
    keywords: 'GupShup, Gupshup, gupshup, gup shup, GupShup romford, Gupshup romford, gupshup romford, gup shup romford, GupShup london, Gupshup london, gupshup london, GupShup collier row, gup shup collier row, gup shup cafe, gup shup chit chat chai, chit chat chai, chai cafe romford, chai shop collier row, authentic south asian chai romford, masala chai essex, karak chai romford, desi chai near me, street food cafe romford, chai and snacks collier row, cozy chai cafe romford, authentic chai experience essex, chai meetup spot romford, casual dining collier row, takeaway chai romford, chai to go romford, samosas romford, pakoras collier row, chaat romford, masala chai romford, garam chai essex, indian tea romford, street snacks collier row, chai breakfast romford, vegetarian snacks romford, where to get authentic chai in romford, best chai spot collier row, chai and samosas near me, quick indian snacks romford, chai near collier row, affordable chai and snacks essex, authentic desi chai collier row, romford chai shop, essex chai cafe, havering borough chai, east london chai spot, chai delivery romford, chai takeaway collier row, breakfast chai romford, evening snacks collier row, study spot with chai romford, meetup cafe romford, halal food near me, halal restaurant near me, chai near me, chai cafe near me, pani puri near me, gol gappe near me, desi breakfast near me, halal breakfast romford, indian restaurant romford, street food near me, samosa chaat, chaat cafe, chaiwala near me, chai shop near me, indian cafe near me, smash burger romford, indian takeaway romford, halal restaurants essex, collier row restaurants',
    canonical: BASE_URL,
    ogTitle: 'Gup Shup – Romford\'s Cosy Chai Cafe & Street Food Spot in Collier Row',
    ogDescription: 'Discover Gup Shup – Collier Row\'s favourite cozy chai cafe and street food spot. Authentic karak chai, samosas, pakoras & desi snacks. Fresh ingredients, traditional recipes, casual vibes.',
    ogImage: `${BASE_URL}/images/branding/storefront.jpg`,
    ogUrl: BASE_URL
  },

  about: {
    title: 'About Gup Shup | Our Story | Cozy Chai Cafe in Collier Row, Romford',
    description: 'Discover the story behind Gup Shup – Collier Row\'s cozy chai cafe and street food spot. ★ 4.8/5 from 1000+ reviews ★ The authentic chai experience Essex has been waiting for. Meet our founder.',
    keywords: 'GupShup, Gupshup, gupshup, gup shup, GupShup romford, gupshup romford, gup shup romford, GupShup collier row, gup shup collier row, gup shup chit chat chai, about gup shup, about gupshup, cozy chai cafe romford, authentic chai experience essex, chai meetup spot romford, casual dining collier row, study spot with chai romford, meetup cafe romford, gup shup story, family owned chai cafe romford, chai cafe reviews, authentic south asian chai romford, street food romford, desi chai collier row, best chai spot collier row, chai shop collier row, romford chai shop, essex chai cafe, east london chai spot, south asian restaurant romford, chai cafe collier row reviews, gup shup photos, founder mohasin khan',
    canonical: `${BASE_URL}/about-us`,
    ogTitle: 'About Gup Shup – Collier Row\'s Cozy Chai Cafe | Our Story',
    ogDescription: 'Discover the story behind Gup Shup – from our founder\'s passion for authentic chai to creating Collier Row\'s favourite casual chai cafe and street food spot.',
    ogImage: `${BASE_URL}/images/about/about-story.jpg`,
    ogUrl: `${BASE_URL}/about-us`
  },

  menu: {
    title: 'Gup Shup Menu | Karak Chai, Samosas, Pakoras, Chaat & Street Snacks | Collier Row, Romford',
    description: 'Full menu from Gup Shup – Collier Row\'s best chai cafe! Karak Chai £2.49, Samosas, Pakoras, Chaat Platter & vegetarian street snacks. Chai breakfast & more. 100% Halal →',
    keywords: 'GupShup menu, Gupshup menu, gupshup menu, gup shup menu, GupShup romford menu, masala chai romford, karak chai romford, samosas romford, pakoras collier row, chaat romford, street snacks collier row, chai breakfast romford, vegetarian snacks romford, garam chai essex, indian tea romford, masala chai essex, pani puri near me, gol gappe near me, samosa chaat, chaat platter, halal menu romford, chai menu collier row, indian street food menu, desi breakfast menu, halwa puri, paratha, smash burger menu, biryani menu, kebab menu, knafeh, indian desserts, vegetarian halal food, vegan options romford, bhel puri, papri chaat, dahi puri, aloo tikki, pav bhaji, keema pav, chicken 65, chilli paneer, mixed grill, lamb chops halal, seekh kebab, paneer tikka, butter chicken, milkshakes, lassi, spanish latte, affordable chai and snacks essex, quick indian snacks romford, evening snacks collier row',
    canonical: `${BASE_URL}/menu`,
    ogTitle: 'Gup Shup Menu – Karak Chai, Samosas, Street Snacks & More | Collier Row',
    ogDescription: 'Browse Gup Shup\'s full menu with prices. Karak chai, samosas, pakoras, chaat & vegetarian street snacks. 100% Halal with vegan options.',
    ogImage: `${BASE_URL}/images/about/about-food.jpg`,
    ogUrl: `${BASE_URL}/menu`
  },

  ordering: {
    title: 'Order Online | Chai Delivery & Takeaway Romford | Gup Shup Collier Row',
    description: 'Chai delivery Romford! Order takeaway karak chai and street snacks from Gup Shup – Collier Row\'s favourite chai cafe. Chai to go, samosas, pakoras delivered to your door →',
    keywords: 'chai delivery romford, chai takeaway collier row, takeaway chai romford, chai to go romford, breakfast chai romford, evening snacks collier row, street food delivery romford, chai and snacks collier row, samosas romford delivery, pakoras collier row delivery, chaat romford delivery, masala chai delivery, indian takeaway romford, collier row takeaway, romford takeaway, halal food delivery, halal food delivery romford, uber eats romford, just eat romford, deliveroo gup shup, order food near me, chai delivery near me, street food delivery, pani puri delivery, samosa chaat delivery, indian food delivery essex, late night chai romford, affordable chai and snacks essex, quick indian snacks romford delivery, order collection romford',
    canonical: `${BASE_URL}/order-online`,
    ogTitle: 'Order Online from Gup Shup – Chai Delivery & Takeaway Collier Row',
    ogDescription: 'Craving authentic chai? Order takeaway or delivery from Gup Shup Romford. Fresh karak chai, samosas & street snacks to your door.',
    ogImage: `${BASE_URL}/images/branding/storefront.jpg`,
    ogUrl: `${BASE_URL}/order-online`
  },

  reservations: {
    title: 'Book a Table | Chai Cafe & Street Food Brunch | Gup Shup Collier Row, Romford',
    description: 'Book a table at Gup Shup chai cafe for breakfast chai, desi brunch & dinner! Collier Row\'s favourite casual dining spot. Reserve now for authentic chai & street food.',
    keywords: 'book table romford, book chai cafe collier row, breakfast chai romford, casual dining collier row, meetup cafe romford, desi breakfast near me, halal breakfast romford, desi brunch, halal brunch romford, restaurant reservation romford, book indian restaurant, weekend brunch romford, family restaurant collier row, group dining romford, chai breakfast romford, chai and snacks collier row, collier row reservation, evening snacks collier row reservation',
    canonical: `${BASE_URL}/book-table`,
    ogTitle: 'Book a Table at Gup Shup – Reserve Your Dining Experience',
    ogDescription: 'Plan your visit to Gup Shup! Reserve a table for an authentic chai and street food experience in Collier Row, Romford.',
    ogImage: `${BASE_URL}/images/branding/storefront.jpg`,
    ogUrl: `${BASE_URL}/book-table`
  },

  location: {
    title: 'Find Gup Shup | Chai Cafe & Street Food Spot | Collier Row, Romford, Essex',
    description: 'Find Gup Shup chai cafe at 3 Clockhouse Lane, Collier Row, Romford RM5 3PH. The best chai shop in Romford, Havering borough & Essex. ★ Free parking ★ Open 6 days.',
    keywords: 'gup shup location, chai near collier row, romford chai shop, essex chai cafe, havering borough chai, east london chai spot, chai cafe collier row, restaurants in collier row, collier row restaurants, indian restaurant romford, restaurants in romford, halal food romford, collier row indian, halal restaurant romford, indian restaurants in romford, restaurants collier row, indian restaurant collier row, best indian restaurant romford, best chai spot collier row, chai and snacks collier row, street food cafe romford, 3 clockhouse lane, RM5 3PH, free parking romford, restaurants near romford, restaurants in havering, chai near me romford, desi chai near me, find chai cafe romford, collier row food',
    canonical: `${BASE_URL}/location`,
    ogTitle: 'Find Gup Shup – Chai Cafe & Street Food in Collier Row, Romford',
    ogDescription: 'Gup Shup chai cafe is at 3 Clockhouse Lane, Collier Row, Romford. Essex\'s favourite authentic chai shop with free parking and easy A12 access.',
    ogImage: `${BASE_URL}/images/branding/storefront.jpg`,
    ogUrl: `${BASE_URL}/location`
  },

  contact: {
    title: 'Contact Gup Shup Chai Cafe | Phone, Email & Socials | Collier Row, Romford',
    description: 'Contact Gup Shup chai cafe in Collier Row, Romford. Call 01708 607796, email us or DM @gupshupldn on Instagram, TikTok & Facebook. Catering enquiries welcome!',
    keywords: 'GupShup contact, Gupshup contact, gupshup contact, gup shup contact, GupShup phone number, gupshup phone number, GupShup romford contact, gupshup romford contact, gup shup romford contact, gupshup instagram, gupshupldn, contact chai cafe romford, contact chai shop collier row, 01708 607796, gup shup email, gupshup email, halal catering romford, indian catering romford, chai cafe contact collier row, meetup cafe romford, evening snacks collier row, party catering halal, wedding catering halal, corporate catering romford',
    canonical: `${BASE_URL}/contact-us`,
    ogTitle: 'Contact Gup Shup – Collier Row\'s Favourite Chai Cafe',
    ogDescription: 'Get in touch with Gup Shup Collier Row! Call us, send an email, or connect on social media. Questions about chai, delivery, or catering – we\'re here!',
    ogImage: `${BASE_URL}/images/branding/storefront.jpg`,
    ogUrl: `${BASE_URL}/contact-us`
  },

  rewards: {
    title: 'Rewards Program | Gup Shup – Earn Points & Get Free Chai | Romford',
    description: 'Join the Gup Shup rewards program and earn points on every purchase. Redeem for free chai, discounts, and exclusive member perks. Sign up today!',
    keywords: 'loyalty program Romford, restaurant rewards program, earn points free chai, Gup Shup rewards, chai loyalty card, Romford restaurant rewards, Indian restaurant loyalty scheme, free food rewards Essex, Toast rewards program, earn points Indian food, member discounts chai shop, free chai Romford, loyalty points halal restaurant, rewards app Indian food, birthday rewards restaurant, student discount Indian restaurant Romford, NHS discount halal food, loyalty scheme South Asian restaurant, cashback Indian food, referral rewards chai shop, exclusive member offers, VIP rewards program Romford, free dessert rewards, loyalty points collection, digital loyalty card restaurant, scan to earn points, redeem rewards Indian food',
    canonical: `${BASE_URL}/rewards`,
    ogTitle: 'Gup Shup Rewards – Earn Points & Enjoy Free Chai',
    ogDescription: 'Join our loyalty program and earn points with every order. Redeem for free chai, snacks, and exclusive member rewards!',
    ogImage: `${BASE_URL}/images/branding/storefront.jpg`,
    ogUrl: `${BASE_URL}/rewards`
  },

  privacy: {
    title: 'Privacy Policy | Gup Shup – Chit Chat Chai | Romford',
    description: 'Privacy Policy for Gup Shup – Chit Chat Chai. Learn how we collect, use, and protect your personal information when you visit our website or restaurant.',
    keywords: 'Gup Shup privacy policy, restaurant privacy policy, data protection Romford, personal information chai shop, GDPR restaurant, privacy policy Indian restaurant',
    canonical: `${BASE_URL}/privacy-policy`,
    ogTitle: 'Privacy Policy | Gup Shup – Chit Chat Chai',
    ogDescription: 'Learn how Gup Shup collects, uses, and protects your personal information.',
    ogImage: `${BASE_URL}/images/branding/storefront.jpg`,
    ogUrl: `${BASE_URL}/privacy-policy`
  },

  terms: {
    title: 'Terms of Service | Gup Shup – Chit Chat Chai | Romford',
    description: 'Terms of Service for Gup Shup – Chit Chat Chai. Read our terms and conditions for using our website, making reservations, and placing orders.',
    keywords: 'Gup Shup terms of service, restaurant terms conditions, terms and conditions Romford, website terms chai shop, legal terms Indian restaurant',
    canonical: `${BASE_URL}/terms`,
    ogTitle: 'Terms of Service | Gup Shup – Chit Chat Chai',
    ogDescription: 'Read the terms and conditions for using Gup Shup website and services.',
    ogImage: `${BASE_URL}/images/branding/storefront.jpg`,
    ogUrl: `${BASE_URL}/terms`
  }
};

// ============================================
// JSON-LD STRUCTURED DATA
// ============================================

// Restaurant Schema (for homepage) with AggregateRating
export const getRestaurantSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Restaurant',
  '@id': `${BASE_URL}/#restaurant`,
  name: BUSINESS_INFO.name,
  image: `${BASE_URL}/images/branding/storefront.jpg`,
  url: BASE_URL,
  telephone: BUSINESS_INFO.phone,
  email: BUSINESS_INFO.email,
  address: {
    '@type': 'PostalAddress',
    streetAddress: BUSINESS_INFO.address.street,
    addressLocality: BUSINESS_INFO.address.area,
    addressRegion: BUSINESS_INFO.address.city,
    postalCode: BUSINESS_INFO.address.postcode,
    addressCountry: 'GB'
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: BUSINESS_INFO.coordinates.lat,
    longitude: BUSINESS_INFO.coordinates.lng
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '22:00'
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Saturday', 'Sunday'],
      opens: '10:00',
      closes: '22:00'
    }
  ],
  servesCuisine: ['Indian', 'Pakistani', 'South Asian', 'Chai', 'Street Food', 'Halal'],
  priceRange: '££',
  acceptsReservations: true,
  menu: `${BASE_URL}/menu`,
  hasMenu: {
    '@type': 'Menu',
    url: `${BASE_URL}/menu`
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.8',
    bestRating: '5',
    worstRating: '1',
    ratingCount: '1086',
    reviewCount: '1086'
  },
  sameAs: [
    'https://instagram.com/gupshupldn',
    'https://facebook.com/gupshupldn',
    'https://tiktok.com/@gupshupldn',
    'https://whatsapp.com/channel/0029VbDLKyS1XquQEwFOe53R'
  ]
});

// Review Schema for Google Reviews
export const getReviewsSchema = (reviews) => ({
  '@context': 'https://schema.org',
  '@type': 'Restaurant',
  '@id': `${BASE_URL}/#restaurant-reviews`,
  name: BUSINESS_INFO.name,
  review: reviews.map(review => ({
    '@type': 'Review',
    author: {
      '@type': 'Person',
      name: review.author
    },
    reviewRating: {
      '@type': 'Rating',
      ratingValue: review.rating.toString(),
      bestRating: '5',
      worstRating: '1'
    },
    reviewBody: review.text
  }))
});

// LocalBusiness Schema
export const getLocalBusinessSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${BASE_URL}/#localbusiness`,
  name: BUSINESS_INFO.name,
  description: BUSINESS_INFO.description,
  image: `${BASE_URL}/images/branding/storefront.jpg`,
  url: BASE_URL,
  telephone: BUSINESS_INFO.phone,
  email: BUSINESS_INFO.email,
  address: {
    '@type': 'PostalAddress',
    streetAddress: BUSINESS_INFO.address.street,
    addressLocality: BUSINESS_INFO.address.area,
    addressRegion: BUSINESS_INFO.address.city,
    postalCode: BUSINESS_INFO.address.postcode,
    addressCountry: 'GB'
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: BUSINESS_INFO.coordinates.lat,
    longitude: BUSINESS_INFO.coordinates.lng
  },
  areaServed: {
    '@type': 'City',
    name: 'Romford'
  }
});

// Menu Schema
export const getMenuSchema = (menuItems) => ({
  '@context': 'https://schema.org',
  '@type': 'Menu',
  '@id': `${BASE_URL}/menu#menu`,
  name: 'Gup Shup Menu',
  description: 'Authentic Indian chai, street food, snacks and beverages',
  url: `${BASE_URL}/menu`,
  mainEntity: menuItems.map(category => ({
    '@type': 'MenuSection',
    name: category.name,
    description: category.description,
    hasMenuItem: category.items.map(item => ({
      '@type': 'MenuItem',
      name: item.name,
      description: item.description,
      offers: {
        '@type': 'Offer',
        price: item.price,
        priceCurrency: 'GBP'
      },
      suitableForDiet: item.dietary?.map(diet => `https://schema.org/${diet}`) || []
    }))
  }))
});

// BreadcrumbList Schema
export const getBreadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url
  }))
});

// WebSite Schema
export const getWebsiteSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${BASE_URL}/#website`,
  url: BASE_URL,
  name: BUSINESS_INFO.name,
  description: BUSINESS_INFO.description,
  publisher: {
    '@id': `${BASE_URL}/#restaurant`
  }
});

// Organization Schema
export const getOrganizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${BASE_URL}/#organization`,
  name: BUSINESS_INFO.name,
  url: BASE_URL,
  logo: `${BASE_URL}/images/branding/logo.png`,
  email: BUSINESS_INFO.email,
  telephone: BUSINESS_INFO.phone,
  address: {
    '@type': 'PostalAddress',
    streetAddress: BUSINESS_INFO.address.street,
    addressLocality: BUSINESS_INFO.address.area,
    addressRegion: BUSINESS_INFO.address.city,
    postalCode: BUSINESS_INFO.address.postcode,
    addressCountry: 'GB'
  },
  sameAs: [
    'https://instagram.com/gupshupldn',
    'https://facebook.com/gupshupldn',
    'https://tiktok.com/@gupshupldn',
    'https://whatsapp.com/channel/0029VbDLKyS1XquQEwFOe53R'
  ]
});

// Video Schema for homepage videos
export const getVideoSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  itemListElement: [
    {
      '@type': 'VideoObject',
      position: 1,
      name: 'Gup Shup - Authentic Chai & Street Food Experience',
      description: 'Experience the authentic taste of Indo-Pakistani chai and street food at Gup Shup in Collier Row, Romford. Watch our team prepare fresh Karak Chai and delicious street food favourites.',
      thumbnailUrl: `${BASE_URL}/images/branding/storefront.jpg`,
      uploadDate: '2024-01-01',
      contentUrl: `${BASE_URL}/videos/gupshup-reel.mp4`,
      embedUrl: `${BASE_URL}/videos/gupshup-reel.mp4`,
      duration: 'PT30S',
      publisher: {
        '@type': 'Organization',
        name: BUSINESS_INFO.name,
        logo: {
          '@type': 'ImageObject',
          url: `${BASE_URL}/images/branding/logo.png`
        }
      }
    },
    {
      '@type': 'VideoObject',
      position: 2,
      name: 'Gup Shup - Behind the Scenes at Our Chai Cafe',
      description: 'Go behind the scenes at Gup Shup Chit Chat Chai. See how we make our signature Karak Chai, samosa chaat, and other South Asian street food delights in Romford.',
      thumbnailUrl: `${BASE_URL}/images/branding/storefront.jpg`,
      uploadDate: '2024-01-01',
      contentUrl: `${BASE_URL}/videos/gupshup-reel-2.mp4`,
      embedUrl: `${BASE_URL}/videos/gupshup-reel-2.mp4`,
      duration: 'PT30S',
      publisher: {
        '@type': 'Organization',
        name: BUSINESS_INFO.name,
        logo: {
          '@type': 'ImageObject',
          url: `${BASE_URL}/images/branding/logo.png`
        }
      }
    },
    {
      '@type': 'VideoObject',
      position: 3,
      name: 'Gup Shup - Delicious Food & Drinks',
      description: 'Discover the delicious food and drinks at Gup Shup in Collier Row. From Kashmiri Pink Tea to Smash Burgers, we have something for everyone. 100% Halal.',
      thumbnailUrl: `${BASE_URL}/images/branding/storefront.jpg`,
      uploadDate: '2024-01-01',
      contentUrl: `${BASE_URL}/videos/gupshup-reel-4.mp4`,
      embedUrl: `${BASE_URL}/videos/gupshup-reel-4.mp4`,
      duration: 'PT30S',
      publisher: {
        '@type': 'Organization',
        name: BUSINESS_INFO.name,
        logo: {
          '@type': 'ImageObject',
          url: `${BASE_URL}/images/branding/logo.png`
        }
      }
    }
  ]
});

// FAQ Schema for common questions
export const getFAQSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Is Gup Shup Halal?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, Gup Shup is 100% Halal.'
      }
    },
    {
      '@type': 'Question',
      name: 'What are Gup Shup\'s opening hours?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'We are open Tuesday to Sunday 9am-10pm (Saturday and Sunday from 10am-10pm). We are closed on Mondays, but open on all UK bank holidays including those that fall on Mondays, from 9am-10pm.'
      }
    },
    {
      '@type': 'Question',
      name: 'Does Gup Shup take reservations?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, we accept reservations through Toast Tables on our website or by calling 01708 607796. Walk-ins are also welcome.'
      }
    },
    {
      '@type': 'Question',
      name: 'Is there parking at Gup Shup?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, there is free street parking available on Clockhouse Lane and nearby streets.'
      }
    },
    {
      '@type': 'Question',
      name: 'Does Gup Shup offer delivery?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, we offer delivery through Uber Eats, Just Eat, and Deliveroo. You can also order for collection through our website.'
      }
    },
    {
      '@type': 'Question',
      name: 'Do you have vegetarian and vegan options?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Absolutely! Most of our menu is vegetarian-friendly, and we have several vegan options too. All dietary information is clearly marked on our menu.'
      }
    },
    {
      '@type': 'Question',
      name: 'What type of cuisine does Gup Shup serve?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Gup Shup serves authentic Indo-Pakistani cuisine including Karak Chai, Kashmiri Pink Tea, street food like Gol Gappe and Samosa Chaat, Smash Burgers, Mixed Grill Platters, and traditional favourites like Pav Bhaji and Chicken 65.'
      }
    },
    {
      '@type': 'Question',
      name: 'What are Gup Shup reviews like?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Gup Shup – Chit Chat Chai has a 4.8/5 rating on Google with over 1000 reviews. Customers love our authentic Karak Chai, friendly service, and delicious street food. We are one of the highest-rated chai cafes in Romford and Essex.'
      }
    },
    {
      '@type': 'Question',
      name: 'Where is Gup Shup located?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Gup Shup – Chit Chat Chai is located at 3 Clockhouse Lane, Collier Row, Romford RM5 3PH. We are near Collier Row Road with free street parking available.'
      }
    },
    {
      '@type': 'Question',
      name: 'Do you serve Pani Puri and Gol Gappe?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes! Gup Shup serves authentic Pani Puri (Gol Gappe) made fresh to order. Our Gol Gappe are crispy puris filled with spiced potatoes, chickpeas, and tangy tamarind water. We also offer Dahi Puri, Bhel Puri, and Papri Chaat.'
      }
    },
    {
      '@type': 'Question',
      name: 'Is there a halal restaurant near me in Romford?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes! Gup Shup in Collier Row, Romford is a 100% halal restaurant serving authentic Indian and Pakistani food. We are one of the best-rated halal restaurants in Romford with a 4.8/5 rating on Google.'
      }
    },
    {
      '@type': 'Question',
      name: 'Do you serve halal breakfast and desi nashta?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes! Gup Shup offers halal breakfast and authentic desi nashta including Halwa Puri, Chana Puri, Paratha with Omelette, and our famous Karak Chai. We serve breakfast from opening time.'
      }
    },
    {
      '@type': 'Question',
      name: 'What is the best Indian restaurant in Romford?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Gup Shup – Chit Chat Chai is rated as one of the best Indian restaurants in Romford with a 4.8/5 Google rating from over 1000 reviews. We serve authentic Indo-Pakistani chai, street food, and main dishes in Collier Row.'
      }
    },
    {
      '@type': 'Question',
      name: 'Do you have Kashmiri Chai (Pink Tea)?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes! We serve authentic Kashmiri Pink Tea (Noon Chai) made traditionally with special tea leaves, milk, and cardamom. It\'s one of our most popular drinks alongside Karak Chai and Garam Chai.'
      }
    }
  ]
});
